import { render, staticRenderFns } from "./AdminProfitBaseDialog.vue?vue&type=template&id=0cad57b3&"
import script from "./AdminProfitBaseDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminProfitBaseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports